import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import BtnCellRenderer from "../../common/BtnCellRenderer";
import { labActions } from "../../../core/actions"; // Adjust this path as needed
import Components from "../..";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions } from "@mui/material";
import { IconButton, Typography } from "@mui/material";
import { Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";

function LabPackageList(props) {
  const dispatch = useDispatch();
  const [rowData, setRowData] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [form, setForm] = useState(null);
  const [mode, setMode] = useState("add");
  const [editingPackageId, setEditingPackageId] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [packageRowData, setpackageRowData] = useState({});
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });

  const emptyForm = {
    package_name: "",
    category: "",
    footer: "",
    labPackageAndTestMapping: [],
  };

  const closeAlert = (e) => {
    console.log("ServerRes", ServerRes);
    setServerRes({ ..."" });
  };
  const handleDelete = (event) => {
    dispatch(
      labActions.updatePackageStatus(packageRowData.id, (res) => {
        if (res === true) {
          var ServerResVal = ServerRes;
          ServerResVal.success = "LabPackage deleted Successfully";
          setServerRes({ ...ServerResVal });
          setConfirm(!confirm);
          setTimeout(() => {
            closeAlert();
          }, 3000);
          dispatch(
            labActions.getPackageList({}, (resList) => setRowData(resList))
          );
        } else {
          alert(res?.message || "Failed to delete Lab Package.");
        }
      })
    );
  };
  const rowStyle = { background: "white" };
  const [columnDefs] = useState([
    {
      headerName: "Package Name",
      field: "package_name",
      sortable: true,
      filter: "agTextColumnFilter",
      floatingFilter: true,
      flex: 1,
      resizable: true,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Category",
      field: "category",
      sortable: true,
      filter: "agTextColumnFilter",
      floatingFilter: true,
      flex: 1,
      resizable: true,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Actions",
      field: "Actions",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      width: 150,
      cellRenderer: "BtnCellRenderer",
      headerClass: "ag-header-left",
    },
  ]);

  const handleAddPackage = () => {
    setForm(emptyForm);
    setMode("add");
    setOpenAddModal(true);
  };

  const handleEdit = (data) => {
    if (!data.labPackageAndTestMapping) {
      data.labPackageAndTestMapping = [];
    }
    setForm(data);
    setMode("edit");
    setEditingPackageId(data.id);
    setOpenAddModal(true);
  };

  const getAggriddata = (e) => {
    if (e.colDef.field == "Actions") {
      setConfirm(!confirm);
      console.log("delete rowdata:", e.data);
      setTimeout(() => {
        setpackageRowData(e.data);
      }, 1000);
    } else {
      handleEdit(e.data);
    }
  };

  const toggle = (event) => {
    setConfirm(!confirm);
  };

  const handleSave = () => {
    if (mode === "add") {
      dispatch(
        labActions.createLabPackage(form, (res) => {
          if (res?.success) {
            alert(res.message);
            setOpenAddModal(false);
            dispatch(
              labActions.getPackageList({}, (resList) => setRowData(resList))
            );
          } else {
            alert(res?.message || "Failed to create Lab Package.");
          }
        })
      );
    } else {
      dispatch(
        labActions.updatePackage(form, editingPackageId, (res) => {
          if (res?.success) {
            alert(res.message);
            setOpenAddModal(false);
            dispatch(
              labActions.getPackageList({}, (resList) => setRowData(resList))
            );
          } else {
            alert(res?.message || "Failed to update Lab Package.");
          }
        })
      );
    }
  };

  useEffect(() => {
    const requestData = {};
    dispatch(
      labActions.getPackageList(requestData, (res) => {
        if (res && Array.isArray(res)) {
          setRowData(res);
        }
      })
    );
  }, [dispatch]);

  if (openAddModal) {
    return (
      <Components.addLabPackage
        onClose={() => setOpenAddModal(false)}
        onSave={handleSave}
        formData={form}
        setFormData={setForm}
        mode={mode}
      />
    );
  }

  return (
    <>
      {ServerRes.success && (
        <Alert severity="success">{ServerRes.success} </Alert>
      )}
      {ServerRes.error && <Alert severity="error">{ServerRes.error} </Alert>}
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Lab Packages</h4>
          <button className="btn btn-primary" onClick={handleAddPackage}>
            Add New
          </button>
        </div>

        <div
          className="ag-theme-balham"
          style={{ height: "500px", width: "100%" }}
        >
          {/* <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    pagination={true}
                    paginationPageSize={15}
                    onRowClicked={(event) => handleEdit(event.data)} // Click row to edit
                /> */}
          <AgGridReact
            frameworkComponents={{ BtnCellRenderer: BtnCellRenderer }}
            pagination={true}
            paginationPageSize={15}
            rowData={rowData}
            columnDefs={columnDefs}
            rowStyle={rowStyle}
            onCellClicked={(e) => {
              console.log("event onCellclicked::", e);
              const field = e.colDef.field;
              const colIndex = e.columnApi
                .getAllColumns()
                ?.findIndex((col) => col.getColDef().field === field);

              console.log("cell clicked ", field, colIndex);
              getAggriddata(e);
            }}
          />
        </div>
        {confirm && (
          <div>
            <Dialog
              open={confirm}
              onClose={toggle}
              aria-labelledby="confirm-dialog-title"
              fullWidth
              maxWidth="sm" // or "xs" for smaller
              scroll="paper"
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  margin: { xs: 1, sm: 2 }, // responsive margin
                  width: "100%",
                },
              }}
            >
              <DialogTitle
                id="confirm-dialog-title"
                sx={{
                  py: 2,
                  px: 3,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Confirm Operation
                <IconButton
                  aria-label="close"
                  onClick={toggle}
                  sx={{
                    color: (theme) => theme.palette.grey[500],
                    ml: "auto",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent sx={{ px: 3, pb: 2 }}>
                <Typography variant="body1" color="textSecondary">
                  This operation cannot be undone! Do you want to continue?
                </Typography>
              </DialogContent>

              <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                  onClick={toggle}
                  variant="outlined"
                  color="inherit"
                  sx={{ textTransform: "none" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleDelete}
                  variant="contained"
                  color="error"
                  sx={{ textTransform: "none", ml: 1 }}
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}
      </div>
    </>
  );
}

export default LabPackageList;
